/**
 * Parsing utilities for step narration metadata persisted in reasoning content.
 * Pure functions with no external dependencies — safe to import in tests.
 */

const STEP_PREFIX_RE = /^\[STEP:(\d+):([^\]]+)\]\n?/;

/** Extracts step metadata encoded as a `[STEP:N:label]` prefix in persisted reasoning content. */
export function parseStepPrefix(content: string): { stepIndex?: number; stepLabel?: string; bodyText: string } {
  const match = content.match(STEP_PREFIX_RE);
  if (match) {
    return { stepIndex: Number(match[1]), stepLabel: match[2], bodyText: content.slice(match[0].length) };
  }
  return { bodyText: content };
}
